import type {
  AceptarConsentimiento,
  ConfirmarIdentidad,
  DecidirPush,
  DefinirCuidador,
  EstadoOnboarding,
  SesionCreada,
} from '@pasos/schemas';
import { enviar, obtener } from '../lib/api.js';

/** Llamadas del onboarding. Una función por endpoint, sin lógica. */

export type TextoDeConsentimiento = { version: string; texto: string; hash: string };

// La respuesta trae el ID token ya canjeado: el canje lo hace el backend, así
// la PWA no lleva SDK de autenticación ni API key (apps/api/src/auth/id-token.ts).
export const validarMagicLink = (token: string) =>
  enviar<SesionCreada>('/api/v1/auth/magic-link', { token });

export const leerEstado = () => obtener<EstadoOnboarding>('/api/v1/onboarding');

export const leerConsentimiento = () =>
  obtener<TextoDeConsentimiento>('/api/v1/onboarding/consentimiento');

export const confirmarIdentidad = (datos: ConfirmarIdentidad) =>
  enviar<EstadoOnboarding>('/api/v1/onboarding/identidad', datos);

export const aceptarConsentimiento = (datos: AceptarConsentimiento) =>
  enviar<EstadoOnboarding>('/api/v1/onboarding/consentimiento', datos);

export const definirCuidador = (datos: DefinirCuidador) =>
  enviar<EstadoOnboarding>('/api/v1/onboarding/cuidador', datos);

export const decidirPush = (datos: DecidirPush) =>
  enviar<EstadoOnboarding>('/api/v1/onboarding/push', datos);
